const status = [
  //Array de Opções usadas no SELECT de atualizar cadastro e cadastrar proprietario
  { id: 1, label: "Andamento", value: "ANDAMENTO" },
  { id: 2, label: "Convertido", value: "CONVERTIDO" },
  { id: 3, label: "Divulgar", value: "DIVULGAR" },
  { id: 4, label: "Sem interesse", value: "SEM_INTERESSE" },
];
export const statusOptions: any[] = status.map((status) => ({
  // Map do array
  id: status.id,
  label: status.label,
  value: status.value,
}));
